export default __webpack_public_path__ + "static/assets/c14c0c1e852949eff4e6c069772b0015.svg";